import React from 'react'

interface AuthLayoutProps {
  children: React.ReactNode
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-gradient-to-br from-primary-50 via-neutral-50 to-secondary-50 p-6">
      {/* Decorative background orbs — more vivid */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -left-32 -top-32 h-[600px] w-[600px] rounded-full bg-primary/15 blur-[120px]" />
        <div className="absolute -bottom-32 -right-32 h-[600px] w-[600px] rounded-full bg-secondary/12 blur-[120px]" />
        <div className="absolute left-1/2 top-1/4 h-[400px] w-[400px] -translate-x-1/2 rounded-full bg-accent/8 blur-[100px]" />
      </div>

      <div className="relative z-10 w-full max-w-md">
        {/* Logo */}
        <div className="mb-8 flex justify-center">
          <img src="/logo.png" alt="PEPS" className="h-32 w-auto" />
        </div>

        {/* Card — stronger shadow & solid white */}
        <div className="rounded-2xl border border-neutral-200 bg-white px-8 py-10 shadow-2xl shadow-neutral-900/10 sm:px-10 sm:py-12">
          {children}
        </div>

        {/* Footer */}
        <p className="mt-8 text-center text-sm text-neutral-400">
          &copy; {new Date().getFullYear()} PEPS &mdash; Plateforme &Eacute;ducative
        </p>
      </div>
    </div>
  )
}
